// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItem-cls1_QR_","cls2":"CreateSocialItem-cls2_L8e CreateSocialItem-cls1_QR_"};